import { createApp } from 'vue';

import { defaultOptions, registerCorePlugins } from '@deepidoo/playdoo/plugins';

import '@deepidoo/deesplay/styles/globals.scss';
import '@deepidoo/playdoo/styles/globals.scss';

import App from './App.vue';

const app = createApp(App);

await registerCorePlugins(app, defaultOptions.value);

app.mount('#play');
